// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class MetadataHandler {
    static hasMetadata(metadataKey, target) {
        return !!target[metadataKey];
    }
    static getDepsMetadata(metadataKey, target) {
        return target[metadataKey];
    }
    static setDepsMetadata(metadataKey, metadata, target) {
        target[metadataKey] = metadata;
    }
    static getMethodMetadata(metadataKey, target) {
        return target[metadataKey];
    }
    static setMethodMetadata(metadataKey, metadata, target) {
        target[metadataKey] = metadata;
    }
}
//# sourceMappingURL=metadata-handler.js.map